import { useMatch, useResolvedPath } from "react-router-dom";

/**
 * Great utility for matching a relative path against the current route. Usually
 * used for components that need to determine the "tab" they're in, inside of an
 * unknown route hierarchy.
 *
 * Example:
 *
 * ```tsx
 * const match = useRelativeMatch("./:tab/*");
 * ```
 *
 * Then, inside of a tab component, you can access the matched parameters:
 *
 * ```tsx
 * <Tabs
 *   value={match?.params.tab || "overview"}
 *   onChange={(value) =>
 *     value === "overview" ? navigate(`./`) : navigate(`./${value}`)
 *   }
 * >
 *   <Tabs.TabItem value="overview">Overview</Tabs.TabItem>
 *   <Tabs.TabItem value="assignments">Assignments</Tabs.TabItem>
 *   <Tabs.TabItem value="mastery">Mastery</Tabs.TabItem>
 * </Tabs>
 * ```
 */
export const useRelativeMatch = (path: string) => {
  const { pathname } = useResolvedPath(path, { relative: "route" });
  console.log("pathname", pathname);
  return useMatch({ path: pathname });
};
